import { getTranslations } from 'next-intl/server';

import { getBubbleNavConfigByDepartment } from './constants';

import { getPageTitle } from '@/modules/browse/helpers';
import {
  type CMS_LOCALES,
  LEGACY_DEFAULT_CMS_CATEGORY_PAGE,
} from '@/modules/cms/constants';
import {
  type CMSBrandCategoryPage,
  type PageMetadata,
} from '@/modules/cms/types';
import { truncate } from '@/modules/text/truncate';

export async function getCategoryPageHeadMetadata(
  categoryPageMetadata: PageMetadata,
  categoryPath: string,
  locale: string
) {
  const t = await getTranslations({ locale, namespace: 'common' });

  const { title, seo, copy = '' } = categoryPageMetadata;
  const truncatedCopy = truncate(copy);

  return {
    title: seo?.metaTitle || title || 'Explore',
    description:
      seo?.metaDescription || truncatedCopy || t('MetaDescr.Default'),
    path: seo?.canonicalLink || `category/${categoryPath}`,
  };
}

export async function getBrandCategoryPageHeadMetadata(
  categoryPageMetadata: CMSBrandCategoryPage,
  categoryPath: string,
  locale: string,
  brandSlug: string
) {
  const t = await getTranslations({ locale, namespace: 'common' });

  const { title, seo, copy = '' } = categoryPageMetadata;
  const truncatedCopy = truncate(copy);

  return {
    title: seo?.metaTitle || title || 'Explore',
    description:
      seo?.metaDescription || truncatedCopy || t('MetaDescr.Default'),
    path: seo?.canonicalLink || `brands/${brandSlug}/c/${categoryPath}`,
  };
}

export function getPageHeaderText(
  categories: string[],
  locale: CMS_LOCALES,
  categoryPageMetadata?: PageMetadata
) {
  const { copy } = categoryPageMetadata || LEGACY_DEFAULT_CMS_CATEGORY_PAGE;

  const title = getPageTitle({
    pageMetadata: categoryPageMetadata,
    categories,
    locale,
  });

  return {
    title,
    description: copy,
  };
}

export function hasBubbleNavConfigForDepartment(
  department?: string
): department is keyof ReturnType<typeof getBubbleNavConfigByDepartment> {
  return department ? department in getBubbleNavConfigByDepartment() : false;
}
